<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.221"
    height="18.244"
    viewBox="0 0 19.221 18.244"
  >
    <g transform="translate(-265.889 -427.878)">
      <path
        d="M279.05,446.122a.5.5,0,0,1-.382-.178l-.764-.906H272.59l-.76.9a.51.51,0,0,1-.421.177c-.751-.057-4.519-.443-4.992-2.309a15.535,15.535,0,0,1-.5-5.01c.1-1.421,1.736-2.046,3.055-2.548a4.892,4.892,0,0,0,1.245-.583,10.391,10.391,0,0,0,.954-3.323c.1-1.56,1.05-4.468,3.911-4.469h0c3.625,0,4.263,2.167,4.64,4.582l.14.944c.231,1.588.239,1.65.969,2.19a5.161,5.161,0,0,0,1.276.529c1.24.408,2.939.967,2.959,2.7,0,.284.01.569.018.853.047,1.851.092,3.6-.916,4.729-1.115,1.251-4.67,1.667-5.071,1.71A.486.486,0,0,1,279.05,446.122Zm-3.961-17.244h0c-2.653,0-2.9,3.41-2.915,3.555,0,.014,0,.03,0,.045-.078.5-.5,3.045-1.189,3.845a4.289,4.289,0,0,1-1.646.865c-1.052.4-2.36.9-2.413,1.678a14.563,14.563,0,0,0,.465,4.693c.211.831,2.295,1.381,3.848,1.542l.743-.884a.5.5,0,0,1,.382-.179h5.779a.5.5,0,0,1,.383.178l.74.878c1.4-.18,3.561-.668,4.17-1.351.744-.833.7-2.389.662-4.038-.007-.288-.014-.578-.018-.866-.011-.951-.906-1.317-2.271-1.766a5.667,5.667,0,0,1-1.558-.676c-1.065-.787-1.123-1.183-1.365-2.849l-.139-.934C278.33,429.979,277.731,428.878,275.089,428.878Zm-3.417,3.523h0Z"
        fill="#777"
      />
      <path
        d="M276.572,435.841h-2a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v3A1,1,0,0,1,276.572,435.841Zm-2-4v3h2v-3Zm0-.5v.5h0Z"
        fill="#777"
      />
      <path
        d="M271.572,442.841h-2a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v3A1,1,0,0,1,271.572,442.841Zm-2-4v3h2v-3Zm0-.5v.5h0Z"
        fill="#777"
      />
      <path
        d="M281.572,442.841h-2a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v3A1,1,0,0,1,281.572,442.841Zm-2-4v3h2v-3Zm0-.5v.5h0Z"
        fill="#777"
      />
      <path
        d="M275.572,439.841c-1.121,0-2-.659-2-1.5s.879-1.5,2-1.5,2,.659,2,1.5S276.694,439.841,275.572,439.841Zm0-2c-.61,0-1,.3-1,.5s.4.5,1,.5,1-.3,1-.5S276.183,437.841,275.572,437.841Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
